import styled from 'particles/themes/styled'
import { Theme } from 'particles/themes'

interface ProgressSectionBlockContainerProps {
    isExpanded?: boolean
    isDisabled?: boolean // This is used to allow the disabled progress section to still trigger the onclick event. (ex: show inform toast when user click on disabled block)
}

export const ProgressSectionBlockContainer = styled.div<ProgressSectionBlockContainerProps>`
    position: relative;
    display: flex;
    width: ${({ isExpanded }) => (isExpanded ? '220px' : '36px')};
    min-height: 90px;
    gap: ${({ theme }) => theme.spacing[400]};
    cursor: pointer;
    ${({ isDisabled }) => isDisabled && 'pointer-events: none;'};
    .indicator-container {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        // Special text size. Didn't add to the default as this will only be used here
        .step {
            font-size: 10px;
            line-height: 13.5px;
        }
        .step-connector {
            height: calc(100% - 20px);
            border-left: ${({ theme }) => `1px dashed ${theme.colors.border.primary}`};
        }
    }
    .step-details-container {
        display: flex;
        flex-direction: column;
        gap: ${({ theme }) => theme.spacing[100]};
        padding-bottom: 8px;
        width: 100%;
        div {
            cursor: pointer;
        }

        .step-title {
            position: relative;
        }
    }
    &.horizontal {
        width: 100%;
        flex-direction: column;
        min-height: fit-content;
        &:last-child {
            width: fit-content;
        }
        .indicator-container {
            width: 100%;
            position: relative;
            display: flex;
            flex-direction: row;
            align-items: center;
            .step-connector {
                width: calc(100% - 20px);
                height: 1px;
                border-bottom: ${({ theme }) => `1px dashed ${theme.colors.border.primary}`};
            }
        }
    }
`

interface StepIndicatorContainerProps {
    isActive?: boolean
    isCommented?: boolean
    isCompleted?: boolean
    isDisabled?: boolean
    isAddStepAction?: boolean
    theme: Theme
}

const getBorderColor = (props: StepIndicatorContainerProps) => {
    const { theme, isDisabled, isAddStepAction, isCommented, isCompleted, isActive } = props
    if (isDisabled) return theme.colors.surface.disable
    if (isAddStepAction) return theme.colors.surface.neutralAction
    if (isCommented || isCompleted || isActive) return 'transparent'
    return theme.colors.border.neutralActionActive
}

const getBackgroundColor = (props: StepIndicatorContainerProps) => {
    const { theme, isActive, isCommented, isCompleted, isDisabled } = props
    if (isDisabled) return theme.colors.surface.disable
    return theme.colors.surface[
        isActive ? 'action' : isCommented ? 'warningPastel' : isCompleted ? 'positivePastel' : 'primary'
    ]
}

export const StepIndicatorContainer = styled.div<StepIndicatorContainerProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border: 1px solid ${getBorderColor};
    border-radius: 50%;
    box-sizing: border-box;
    background: ${getBackgroundColor};
    .step {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
    }
`

export const ErrorDot = styled.div`
    position: absolute;
    right: -10px;
    top: 0px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.surface.error};
`

export const SideNavigatorContainer = styled.div`
    width: fit-content;
    .progress-block {
        &:last-child {
            .step-connector {
                display: none;
            }
        }
    }
    .add-step {
        display: flex;
        gap: 16px;
        align-items: center;
        cursor: pointer;
    }
    &.horizontal {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
`
